import React from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TikTokIcon } from '@/components/SocialIcons.jsx';

const socialLinks = [
  { label: 'Instagram', icon: Instagram, href: 'https://www.instagram.com/lu.pistiner/' },
  { label: 'LinkedIn', icon: Linkedin, href: 'https://www.linkedin.com/in/lucilapistiner/' },
  { label: 'TikTok', icon: TikTokIcon, href: 'https://www.tiktok.com/@lu.pistiner' },
  { label: 'Email', icon: Mail, href: 'mailto:info@lucilapistiner.com' }
];

function Footer({ showCredit = true }) {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-4 py-9 text-center sm:px-6 md:py-11 lg:px-8">
        <h2 className="font-rocky-light text-3xl font-light leading-none text-primary-foreground sm:text-4xl md:text-[2.7rem]">
          Sumate a nuestra comunidad de más de 300.000 familias
        </h2>

        <div className="mt-9 flex justify-center gap-3 md:mt-10 md:gap-5">
          {socialLinks.map(({ label, icon: Icon, href }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('http') ? '_blank' : undefined}
              rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
              aria-label={label}
              className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary-foreground transition-transform hover:scale-105 md:h-14 md:w-14"
            >
              <Icon className="h-6 w-6" strokeWidth={2.3} />
            </a>
          ))}
        </div>

        <nav className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 md:mt-7">
          <Link to="/privacidad" className="font-rocky-light text-lg text-primary-foreground underline decoration-transparent underline-offset-4 transition-all duration-200 hover:-translate-y-0.5 hover:text-white hover:decoration-white md:text-xl">Políticas de privacidad</Link>
          <Link to="/terminos-y-condiciones" className="font-rocky-light text-lg text-primary-foreground underline decoration-transparent underline-offset-4 transition-all duration-200 hover:-translate-y-0.5 hover:text-white hover:decoration-white md:text-xl">Términos y condiciones</Link>
          <Link to="/preguntas-frecuentes" className="font-rocky-light text-lg text-primary-foreground underline decoration-transparent underline-offset-4 transition-all duration-200 hover:-translate-y-0.5 hover:text-white hover:decoration-white md:text-xl">Preguntas frecuentes</Link>
        </nav>

        <p className="mx-auto mt-6 max-w-3xl text-center text-sm font-normal tracking-wide text-primary-foreground md:text-base">
          Copyright © 2026 Lucila Pistiner | Powered by Lucila Pistiner
        </p>
        {showCredit && (
          <a
            href="https://www.ucoode.com.ar"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Abrir sitio de UCODE"
            className="mx-auto mt-3 inline-flex w-fit items-center text-center text-[11px] font-bold uppercase tracking-[0.18em] text-primary-foreground underline decoration-primary-foreground/75 underline-offset-4 transition-all hover:text-white hover:decoration-white hover:decoration-2 md:text-xs"
          >
            HECHO POR UCODE
          </a>
        )}
      </div>
    </footer>
  );
}

export default Footer;
